/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type OverviewProjects_tradeFirm = {
    readonly serviceId: string | null;
    readonly publicProfile: {
        readonly urlLabel: string | null;
        readonly liveDesignProjects?: ReadonlyArray<{
            readonly serviceId: string | null;
            readonly status: string | null;
            readonly visibility: boolean | null;
            readonly " $fragmentRefs": FragmentRefs<"DisplayDesignProjectTile_designProject">;
        } | null> | null;
        readonly editModeDesignProjects?: ReadonlyArray<{
            readonly serviceId: string | null;
            readonly status: string | null;
            readonly visibility: boolean | null;
            readonly " $fragmentRefs": FragmentRefs<"EditDesignProjectTile_designProject">;
        } | null> | null;
    } | null;
    readonly " $refType": "OverviewProjects_tradeFirm";
};
export type OverviewProjects_tradeFirm$data = OverviewProjects_tradeFirm;
export type OverviewProjects_tradeFirm$key = {
    readonly " $data"?: OverviewProjects_tradeFirm$data;
    readonly " $fragmentRefs": FragmentRefs<"OverviewProjects_tradeFirm">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "visibility",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "OverviewProjects_tradeFirm",
  "type": "TradeFirmType",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isEditMode",
      "type": "Boolean"
    }
  ],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "publicProfile",
      "storageKey": null,
      "args": null,
      "concreteType": "TradeFirmPublicProfileType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "urlLabel",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "Condition",
          "passingValue": false,
          "condition": "isEditMode",
          "selections": [
            {
              "kind": "LinkedField",
              "alias": "liveDesignProjects",
              "name": "designProjectsCover",
              "storageKey": null,
              "args": null,
              "concreteType": "DesignProjectCover",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                (v2/*: any*/),
                {
                  "kind": "FragmentSpread",
                  "name": "DisplayDesignProjectTile_designProject",
                  "args": null
                }
              ]
            }
          ]
        },
        {
          "kind": "Condition",
          "passingValue": true,
          "condition": "isEditMode",
          "selections": [
            {
              "kind": "LinkedField",
              "alias": "editModeDesignProjects",
              "name": "designProjects",
              "storageKey": "designProjects(status:[\"ACTIVE\",\"PENDING\"],visibility:[\"Y\",\"N\"])",
              "args": [
                {
                  "kind": "Literal",
                  "name": "status",
                  "value": [
                    "ACTIVE",
                    "PENDING"
                  ]
                },
                {
                  "kind": "Literal",
                  "name": "visibility",
                  "value": [
                    "Y",
                    "N"
                  ]
                }
              ],
              "concreteType": "designProject",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                (v2/*: any*/),
                {
                  "kind": "FragmentSpread",
                  "name": "EditDesignProjectTile_designProject",
                  "args": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = 'c6a3a8966aeaf2bacb22681bd86df1af';
export default node;
